import { InnerContentItem } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { slugify } from "@certn/utils";

export function TextSummaryField({
  field,
}: {
  field: components["schemas"]["TextCheckField"];
}) {
  return (
    <InnerContentItem
      label={field.label}
      testID={`summary-${slugify(field.label)}-text`}
    >
      {field.value ?? "-"}
    </InnerContentItem>
  );
}
